import { useSelector } from 'react-redux'

import { useBasketRecipes } from 'hooks/basket/useBasketRecipes'
import { useRecipe } from 'hooks/menu-recipes/useRecipe'
import type { RecipeUUID } from 'reducers/menu-recipes/recipes'
import { locationQuery } from 'selectors/routing'

export const useIsAdminMenuPreview = (): boolean => {
  const query = useSelector(locationQuery)

  return !!(query && query['preview[menu_id]'])
}

export const useIsRecipeInStock = (id: RecipeUUID | null): boolean => {
  const recipe = useRecipe(id)
  const coreId = recipe?.coreId || null

  const isAdmin = useIsAdminMenuPreview()

  const { basketHasRecipe } = useBasketRecipes()
  const isInBasket = !!coreId && basketHasRecipe(coreId)
  const isAvailable = !!recipe?.isAvailable

  return isAdmin || isInBasket || isAvailable
}
